import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Observable, Subject } from 'rxjs';
import { ResponseApiModel } from '../_models/response-api.model';
import { CookieService } from 'ngx-cookie-service';

const API_CHANGE_PASSWORD = '/employeePublic/profile/change-password';

/**
 * EmployeeService (ptnw-3.0-productivity)
 *
 * REVISI 2026-09-07: file ini sebelumnya berisi salinan lengkap ~90 method HTTP
 * (family /employee/hrd/*, /employeeAdmin/dev/*, /movement/*, /productivity/*, dll),
 * TIDAK SATU PUN dipanggil di repo ini kecuali `changePassword()` (dikonfirmasi via
 * grep menyeluruh -- pemakaian lain EmployeeService di repo ini cuma properti
 * `mobileToggleEmit` di subheader.component.ts). Dihapus sekalian saat audit path
 * module Employee/PettyCash pasca-split (ticket #845 lanjutan), method
 * `changePassword()` yang live DIPERTAHANKAN apa adanya (sudah benar, path
 * employeePublic/profile/change-password) -- lihat plan doc ptnw-3.0-docs
 * brainstorms/2026-09-03-authorization2-rbac-pettycash-plan.md §9.6.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  public mobileToggleEmit: Subject<boolean> = new Subject<boolean>();
  public mobileToggleEmitObs = this.mobileToggleEmit.asObservable();
  public loadBankAccountEmit: Subject<boolean> = new Subject<boolean>();
  public loadBankAccountEmitObs = this.loadBankAccountEmit.asObservable();

  constructor(
    private http: HttpClient,
    private globalService: GlobalService,
    private cookieService: CookieService,
  ) {
    this.mobileToggleEmit.next(false);
    this.loadBankAccountEmit.next(false);
  }

  public header(module = 'employee') {
    return {
      headers: new HttpHeaders()
        .set('token', this.cookieService.get('_q'))
        .set('module', localStorage.getItem(module))
        .set('group', this.cookieService.get('_g'))
    };
  }

  public changePassword(param: { curPass: string, newPass: string, newPass1: string, }): Observable<ResponseApiModel> {
    return this.http.post<ResponseApiModel>(
      this.globalService.apiVersionHost + API_CHANGE_PASSWORD, param, this.header('employeePublic')
    );
  }

}
